module.exports = __webpack_public_path__ + "fonts/WorkSans-Regular.ed6fb88.woff2";